<template>
  <div class="service-selection">
    <md-field>
      <md-select
        v-model="newServiceSelection"
        placeholder="Service hinzufügen"
        @md-closed="addService"
      >
        <md-option v-for="item in services" :key="item.id" :value="item.id">
          {{ item.name }}
        </md-option>
      </md-select>
    </md-field>
    <div :key="member_services.length">
      <md-card
        v-for="member_service in member_services.filter(ms => !ms.deleted_at)"
        :key="member_service.id"
      >
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>sentiment_very_satisfied</md-icon>
          </div>
          <h4 class="title">
            {{ member_service.service.name }}
            <span style="color: #b7b7b7;float: right;">
              <md-button
                @click="$set(member_service, 'deleted_at', new Date())"
                class="md-icon-button md-dense md-round"
                style="margin: .2rem;"
              >
                <md-icon>remove</md-icon>
              </md-button>
            </span>
          </h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout spacing">
            <label class="md-layout-item md-size-25 md-form-label">
              Anzahl
            </label>
            <div class="md-layout-item">
              <md-field class="md-invalid">
                <md-input
                  v-model="member_service.delivery_amount"
                  type="number"
                />
              </md-field>
            </div>
          </div>
          <div class="md-layout spacing">
            <label class="md-layout-item md-size-25 md-form-label">
              Zeitraum
            </label>
            <div class="md-layout-item">
              <div style="display: flex; align-items: center;flex-wrap: wrap;">
                <div>
                  <md-datepicker
                    @input="e => (member_service.start = toIsoDate(e))"
                    :value="
                      member_service.start
                        ? toGermanDate(member_service.start)
                        : null
                    "
                  />
                </div>
                <div style="width:50px;text-align: center;">bis</div>
                <div>
                  <md-datepicker
                    @input="e => (member_service.end = toIsoDate(e))"
                    :value="
                      member_service.end
                        ? toGermanDate(member_service.end)
                        : null
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout spacing">
            <label class="md-layout-item md-size-25 md-form-label">
              Lieferung <template v-if="nonMember">an</template>
            </label>
            <div class="md-layout-item" style="display: flex;">
              <md-autocomplete
                :key="member_service.recipient_id + showCreateContactableDialog"
                :value="getPersonOrganizationLabel(member_service.recipient)"
                :md-options="[{ name: 'Neu ...' }, ...people, ...organizations]"
                @md-selected="e => pickServicerecipient(member_service, e)"
                :md-fuzzy-search="false"
              >
                <div
                  class="md-list-item-content md-ripple"
                  style="padding: 0; min-height: 0"
                  slot="md-autocomplete-item"
                  slot-scope="{ item, term }"
                  :style="{ fontStyle: item.id ? null : 'italic' }"
                >
                  <md-icon
                    style="margin-right: 10px;"
                    v-if="
                      item.type === 'people' || item.type === 'organizations'
                    "
                    >{{
                      item.type === "people" ? "person" : "business"
                    }}</md-icon
                  >
                  <md-highlight-text :md-term="term">
                    {{ getPersonOrganizationLabel(item) }}</md-highlight-text
                  >
                </div>
              </md-autocomplete>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <md-dialog
      :md-active.sync="showCreateContactableDialog"
      class="create-contactable-dialog"
    >
      <md-dialog-title>Neuer Kontakt</md-dialog-title>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-card style="margin-top:0">
            <md-card-content>
              <EditContactable
                style="width: 500px;"
                ref="createContactableDialog"
                @saved="handleContactableCreation"
              ></EditContactable>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <md-dialog-actions>
        <md-button @click="showCreateContactableDialog = false"
          >Abbrechen</md-button
        >
        <md-button
          @click="$refs.createContactableDialog.save()"
          class="md-success"
          >Übernehmen und einfügen</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  components: {
    EditContactable: () =>
      import(
        /* webpackChunkName: "EditContactable" */ "@/components/Clouseau/EditContactable.vue"
      )
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    nonMember: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCreateContactableDialog: false,
      newServiceSelection: null,
      member_services: []
    };
  },
  created() {
    this.member_services = this.value;
  },
  computed: {
    people() {
      return this.$store.getters["people/list"];
    },
    services() {
      return this.$store.getters["services/list"];
    },
    organizations() {
      return this.$store.getters["organizations/list"];
    }
  },
  watch: {
    member_services: {
      deep: true,
      immediate: false,
      handler(member_services, old) {
        this.$emit("input", member_services);
      }
    }
  },
  methods: {
    addService(e) {
      if (!this.newServiceSelection) return;
      this.member_services.unshift({
        new: true,
        type: "member-services",
        id: +new Date(),
        service: this.services.find(s => s.id === this.newServiceSelection),
        recipient_type: "person",
        recipient_id: null,
        delivery_amount: 1,
        relationshipNames: ["recipient", "service"]
      });
      this.newServiceSelection = null;
    },
    handleContactableCreation(contactable) {
      this.$store.dispatch("people/list", { page: { size: 500 } });
      this.pickServicerecipient(
        this.createContactableDialogParent,
        contactable
      );
      this.showCreateContactableDialog = false;
    },

    pickServicerecipient(member_service, recipient) {
      if (recipient.id) {
        member_service.recipient_type = recipient.type;
        member_service.recipient_id = recipient.id;
        member_service.recipient = recipient;
      } else {
        this.createContactableDialogParent = member_service;
        this.showCreateContactableDialog = true;
      }
    }
  }
};
</script>
